import { render, staticRenderFns } from "./country-guides.vue?vue&type=template&id=c2beb0d6&"
import script from "./country-guides.vue?vue&type=script&lang=js&"
export * from "./country-guides.vue?vue&type=script&lang=js&"
import style0 from "./country-guides.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopScreen: require('/builds/pagsmile/front-end/pagsmile-web/components/TopScreen.vue').default,FooterTop: require('/builds/pagsmile/front-end/pagsmile-web/components/footer/footerTop.vue').default})
